import React from 'react';
import { Section, Content } from '@layout';
import Gallery from './Gallery';
import { Button, ButtonsWrapper } from '@input';
import styles from './Photos.module.scss';

export default React.memo(function Photos() {
  return (
    <Section
      className={styles.wrapper}
      wrapContent={false}
    >
      <Content className={styles.top}>
        <h2>Our strength is our people</h2>
        <p>
          Our lab is comprised of a diverse group of students and
          researchers working together in team-based research projects that
          investigate a wide range of topics, from understanding clumped
          isotope systematics to applications for reconstructing past and
          future environments.
        </p>
      </Content>

      <div className={styles.gallery}>
        <div className={styles.divider} />
        <Gallery />
        <div className={styles.divider} />
      </div>

      <Content>
        <ButtonsWrapper className={styles.buttons}>
          <Button
            icon="person"
            theme="white"
          >
            Learn more about our group
          </Button>

          <Button
            icon="heart"
            theme="white"
          >
            Center for Diverse Leadership in Science
          </Button>
        </ButtonsWrapper>
      </Content>
    </Section>
  );
});
